import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout as LayoutWrapper } from 'antd';
import useWindowSize from 'library/hooks/useWindowSize';
import LayoutProvider from 'context/LayoutProvider';
import {
    DOCTOR_PROFILE_PAGE,
    DOCTOR_SETTINGS_PAGE,
    LISTING_POSTS_PAGE,
    ADD_HOTEL_PAGE,
    PRICING_PLAN_PAGE,
    SINGLE_POST_PAGE,
    PRIVACY_PAGE,
    CHANGE_PASSWORD_PAGE,
    FORGET_PASSWORD_PAGE,
    AGENT_IMAGE_EDIT_PAGE,
    CHANGE_USER_PASSWORD_PAGE,
} from 'settings/constant';

import Header from './Header/Header';
import Footer from './Footer/Footer';
import ReactGA from 'react-ga';
import { liveSiteUrl } from 'util/ServerUtil';
const { Content } = LayoutWrapper;

// ReactGA.initialize('UA-146514891-1');
ReactGA.initialize('UA-146514891-1', {
  debug: true,
  titleCase: false
});

export default withRouter(function Layout({ children, location }) {
  const { width } = useWindowSize();
  const singlePageUrlFromConst = SINGLE_POST_PAGE.split('/');
  const singlePageUrlFormLocation = location.pathname.split('/');

  useEffect(()=>{
    if(liveSiteUrl === 'https://patients.edentalportal.com/'){
      //// console.log("Curent page++++ ", window.location.pathname)
      ReactGA.pageview(window.location.pathname + window.location.search);
      // console.log("Curent page++++ At end+++", window.location.pathname)
    }
  })

  return (
    <LayoutProvider>
      {location.pathname === CHANGE_PASSWORD_PAGE ||
      location.pathname === FORGET_PASSWORD_PAGE ? (
        <Content>{children}</Content>
      ) : (
        <Fragment>
          <Header />
          <Content>{children}</Content>
          {
          // location.pathname === LISTING_POSTS_PAGE ||
          location.pathname === PRICING_PLAN_PAGE ||
          location.pathname === ADD_HOTEL_PAGE ||
          location.pathname === DOCTOR_PROFILE_PAGE ||
          location.pathname === CHANGE_PASSWORD_PAGE ||
          location.pathname === FORGET_PASSWORD_PAGE ||
          location.pathname === PRIVACY_PAGE ||
          location.pathname ===
            `${DOCTOR_SETTINGS_PAGE + AGENT_IMAGE_EDIT_PAGE}` ||
          location.pathname ===
            `${DOCTOR_SETTINGS_PAGE + CHANGE_USER_PASSWORD_PAGE}` ||
          location.pathname === DOCTOR_SETTINGS_PAGE ? (
            <div style={{ height: '33px' }} />
          ) : (
            <Fragment>
              <Footer />
              {singlePageUrlFormLocation[1] === singlePageUrlFromConst[1] && (
                <Fragment>
                  {width < 1200 && <div style={{ height: '74px' }} />}
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      )}
    </LayoutProvider>
  );
});
